<template>
  <div class="ai-loading w-full" v-if="resultsEn">
    <div class="md:flex mb-3">
      <!-- <a class="btn btn-clear mx-2 flex items-center justify-center mb-2 md:mb-0 p-2"
        @click="reGenerate"><img src="@/assets/image/ai/re_icon.png" alt="" class="object-contain mr-1">重新生成
      </a> -->
      <!-- <a class="btn btn-clear mx-2 inline-block flex items-center justify-center mb-2 md:mb-0"
        @click="copyAll(resultsEn)"><img src="@/assets/image/ai/copy.png" alt="" class="object-contain mr-1">全文複製
      </a> -->
      <a class="btn btn-clear mx-2 flex items-center justify-center p-2"
        v-if="ttsUrlFemale && ttsUrlMale"
        @click="toggleSwitch()" :class="{ 'btn-player-disabled': !ttsUrlFemale || !ttsUrlMale, 'btn-clear': ttsUrlFemale && ttsUrlMale, 'btn-clear--active': ttsUrlFemale && ttsUrlMale && isShowPlayer }">
        <img src="@/assets/image/ai/player_icon.png" alt="" class="object-contain mr-1">Content narration
      </a>
    </div>
    <div class="sm:flex items-center justify-between mb-3" v-if="ttsUrlMale && ttsUrlFemale && isShowPlayer">
      <div class="toggle-switch mr-sm-2 cursor-pointer relative flex items-center justify-center" @click="toggleGender()">
        <p class="text-center text-white font-semibold">{{ gender }}</p>
        <div class="absolute toggle-switch-button" :class="{ 'toggle-switch-button_female': gender === 'female', 'toggle-switch-button_male': gender === 'male' }">
          <img src="@/assets/image/ai/icon_voice_female_on.png" alt="" class="object-contain female inline">
          <img src="@/assets/image/ai/icon_voice_male_on.png" alt="" class="object-contain male inline">
        </div>
      </div>
      <!-- <AudioPlayer class="flex-1" :ttsUrl="ttsUrlSwitch" /> -->
      <VideoPlayer class="flex-1 ml-2" :ttsUrl="ttsUrlSwitch" />
    </div>
    <div class="bg-white w-full h-full results py-3 md:py-4 px-2 md:px-3">
      <WordDictM class="lg:hidden" v-if="dictIdx !== -1" v-on:closeDict="closeDict" :content="ductWord" />

      <div class="flex" v-if="resultsEn">
        <div class="flex-1 px-2">
          <div class="results_en" :style="`font-size: ${fontSize}px`" id="target">
            <p class="m-0 p-0" v-if="$route.name === 'SpeechAI'"><span class="m-0 p-0" v-for="(item, index) in sentenceSpliter" :key="index" :class="{ 'active': dictIdx === index, 'cursor-pointer isDictionary': isDictionary && !isRegular(item) }" @click.stop="setIdxEn(item, index)">{{ item }}<WordDict class="hidden lg:block" v-if="dictIdx === index" v-on:closeDict="closeDict" :content="ductWord"/></span></p>
            <p class="m-0 p-0" v-if="$route.name === 'SpeechAIJp' || $route.name === 'viewGenerate'">{{ resultsEn }}</p>
          </div>
          <div id="resultsZh" ref="resultsZh" class="results_zh pl-2 mt-4" v-if="isShowZn && resultsZh" :style="`font-size: ${fontSize}px`">
            <p v-html="resultsZh.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></p>
          </div>
        </div>
        <div class="flex flex-col pr-2 pl-2 pl-md-3">
          <a class="block mb-3 hover-item cursor-pointer tooltip-outer" @click="fontSize = 14" :class="{ 'active': fontSize === 14 }">
            <img src="@/assets/image/ai/btn_A1.png" alt="" class="off">
            <img src="@/assets/image/ai/btn_A1_active.png" alt="" class="on">
            <span class="tooltiptext">字型變小</span>
          </a>
          <a class="block mb-3 hover-item cursor-pointer tooltip-outer" @click="fontSize = 16" :class="{ 'active': fontSize === 16 }">
            <img src="@/assets/image/ai/btn_A2.png" alt="" class="off">
            <img src="@/assets/image/ai/btn_A2_active.png" alt="" class="on">
            <span class="tooltiptext">字型一般</span>
          </a>
          <a class="block mb-3 hover-item cursor-pointer tooltip-outer" @click="fontSize = 18" :class="{ 'active': fontSize === 18 }">
            <img src="@/assets/image/ai/btn_A3.png" alt="" class="off">
            <img src="@/assets/image/ai/btn_A3_active.png" alt="" class="on">
            <span class="tooltiptext">字型放大</span>
          </a>
          <a class="block mb-3 hover-item cursor-pointer tooltip-outer" @click="toggleZn" :class="{ 'active': isShowZn }">
            <img src="@/assets/image/ai/btn_A4.png" alt="" class="off" v-if="$route.name !== 'SpeechAIJp'">
            <img src="@/assets/image/ai/btn_AItalk_lightBlue.png" alt="" class="off" v-if="$route.name === 'SpeechAIJp'">
            <img src="@/assets/image/ai/btn_A4_active.png" alt="" class="on" v-if="$route.name !== 'SpeechAIJp'">
            <img src="@/assets/image/ai/btn_AItalk_lightBlue_active.png" alt="" class="on" v-if="$route.name === 'SpeechAIJp'">
            <span class="tooltiptext">中文翻譯</span>
          </a>
          <a class="block hover-item cursor-pointer tooltip-outer" @click="isDictionary = !isDictionary" :class="{ 'active': isDictionary }" v-if="$route.name === 'SpeechAI'">
            <img src="@/assets/image/ai/btn_A5.png" alt="" class="off">
            <img src="@/assets/image/ai/btn_A5_active.png" alt="" class="on">
            <span class="tooltiptext">字典模式</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- eslint-disable no-multiple-empty-lines -->
<script>
  // import api from '@/api'
  import WordDict from '@/components/AiHelper/WordDict'
  import WordDictM from '@/components/AiHelper/WordDictM'
  // import AudioPlayer from '@/components/AiHelper/speech/AudioPlayer'
  import VideoPlayer from '@/components/AiHelper/speech/VideoPlayer'
  import dictApi from '@/dictApi'
  import allJs from '@/components/all.js'
  export default {
    name: 'GenerateResults',
    data () {
      return {
        timer: null,
        fontSize: 16,
        isShowZn: false,
        isShowPlayer: false,
        isDictionary: true,

        ductWord: null,
        dictIdx: -1,

        gender: 'female',
        // ttsUrlFemale: 'https://storage.liveabc.com/generate/speech/speech_5YdhVV.mp3',
        // ttsUrlMale: 'https://storage.liveabc.com/generate/speech/speech_YgOMMb.mp3',
        // resultsEn: 'greetings Ladies and gentlemen,\n\nGood morning/afternoon/evening! It is my pleasure to welcome all of you, especially the students, to this special event today. Today, we are here to discuss a topic that I believe will interest all of you - the art of selecting movies.\n\nMovies have always been a great source of entertainment and inspiration for people of all ages. However, with so many options available, it can sometimes be overwhelming to choose a movie that suits our preferences and interests.greetings Ladies and gentlemen,\n\nGood morning/afternoon/evening! It is my pleasure to welcome all of you, especially the students, to this special event today. Today, we are here to discuss a topic that I believe will interest all of you - the art of selecting movies.\n\nMovies have always been a great source of entertainment and inspiration for people of all ages. However, with so many options available, it can sometimes be overwhelming to choose a movie that suits our preferences and interests.greetings Ladies and gentlemen,\n\nGood morning/afternoon/evening! It is my pleasure to welcome all of you, especially the students, to this special event today. Today, we are here to discuss a topic that I believe will interest all of you - the art of selecting movies.\n\nMovies have always been a great source of entertainment and inspiration for people of all ages. However, with so many options available, it can sometimes be overwhelming to choose a movie that suits our preferences and interests.greetings Ladies and gentlemen,\n\nGood morning/afternoon/evening! It is my pleasure to welcome all of you, especially the students, to this special event today. Today, we are here to discuss a topic that I believe will interest all of you - the art of selecting movies.\n\nMovies have always been a great source of entertainment and inspiration for people of all ages. However, with so many options available, it can sometimes be overwhelming to choose a movie that suits our preferences and interests.greetings Ladies and gentlemen,\n\nGood morning/afternoon/evening! It is my pleasure to welcome all of you, especially the students, to this special event today. Today, we are here to discuss a topic that I believe will interest all of you - the art of selecting movies.\n\nMovies have always been a great source of entertainment and inspiration for people of all ages. However, with so many options available, it can sometimes be overwhelming to choose a movie that suits our preferences and interests.greetings Ladies and gentlemen,\n\nGood morning/afternoon/evening! It is my pleasure to welcome all of you, especially the students, to this special event today. Today, we are here to discuss a topic that I believe will interest all of you - the art of selecting movies.\n\nMovies have always been a great source of entertainment and inspiration for people of all ages. However, with so many options available, it can sometimes be overwhelming to choose a movie that suits our preferences and interests.greetings Ladies and gentlemen,\n\nGood morning/afternoon/evening! It is my pleasure to welcome all of you, especially the students, to this special event today. Today, we are here to discuss a topic that I believe will interest all of you - the art of selecting movies.\n\nMovies have always been a great source of entertainment and inspiration for people of all ages. However, with so many options available, it can sometimes be overwhelming to choose a movie that suits our preferences and interests.'
      }
    },
    props: {
      resultsEn: {
        type: String,
        default: null
      },
      resultsZh: {
        type: String,
        default: null
      },
      aiType: {
        type: String,
        default: 'letter'
      },
      ttsUrlMale: {
        type: String,
        default: null
      },
      ttsUrlFemale: {
        type: String,
        default: null
      }
    },
    mixins: [
      allJs
    ],
    components: {
      WordDict,
      WordDictM,
      // AudioPlayer,
      VideoPlayer
    },
    mounted () {
    },
    computed: {
      ttsUrlSwitch () {
        let self = this
        if (self.gender === 'female') {
          return self.ttsUrlFemale
        } else {
          return self.ttsUrlMale
        }
      },
      sentenceSpliter () {
        let self = this
        if (self.resultsEn) {
          const str = self.resultsEn
          const pattern = /\p{L}[\p{L}\p{N}]*(?:['’\-][\p{L}\p{N}]+)*|\p{N}+|[^\p{L}\p{N}'’\-\s]|\s+/gu
          return str ? str.match(pattern) || [] : []
        }
        return []
      }
    },
    watch: {
    },
    destroyed () {
    },
    methods: {
      toggleGender() {
        this.gender = this.gender === 'female' ? 'male' : 'female'
      },

      async toggleZn () {
        let self = this
        if (self.resultsZh) {
          self.isShowZn = !self.isShowZn
        } else {
          self.$store.dispatch('isLoading', true)
          let data = await self.get_Translate_Speech(self.resultsEn)

          if (data) {
            self.$emit('resultsZh', data)
            self.isShowZn = !self.isShowZn
            self.$emit('getZnPopUp')
            self.$store.dispatch('isLoading', false)
          } else {
            self.$emit('failPopUp')
            self.$store.dispatch('isLoading', false)
          }
          // let path = `https://ja3b6k591e.execute-api.ap-northeast-1.amazonaws.com/default/generate?func=translate`

          // await api.post(path, {
          //   message: self.resultsEn
          // })
          // .then((res) => {
          //   if (res.data && res.data.result) {
          //     self.$emit('resultsZh', res.data.result)
          //     self.isShowZn = !self.isShowZn
          //     self.$emit('getZnPopUp')
          //   } else {
          //     self.$emit('failPopUp')
          //   }
          // })
          // .catch(() => {
          //   self.$emit('failPopUp')
          // })
        }
      },

      selectText (nodeId) {
        const node = document.getElementById(nodeId)

        if (document.body.createTextRange) {
          const range = document.body.createTextRange()
          range.moveToElementText(node)
          range.select()
        } else if (window.getSelection) {
          const selection = window.getSelection()
          const range = document.createRange()
          range.selectNodeContents(node)
          selection.removeAllRanges()
          selection.addRange(range)
        } else {
          console.warn('Could not select text in node: Unsupported browser.')
        }
      },

      async copyAll (text) {
        let self = this
        self.selectText('target')

        navigator.clipboard
          .writeText(text)
          .then(() => {
            alert('successfully copied')
          })
          .catch(() => {
            alert('something went wrong')
          })

        // self.$swal.fire({
        //   position: "top-end",
        //   icon: "success",
        //   title: "Your work has been saved",
        //   showConfirmButton: false,
        //   timer: 1000
        // })
      },

      closeDict () {
        let self = this
        self.ductWord = null
        self.dictIdx = -1
      },

      async setIdxEn (item, idx) {
        let self = this
        if (self.isDictionary && !self.isRegular(item)) {
          const { data } = await dictApi.get(`/v1/livelibrary/Dict/Word/${item}`)
          self.dictIdx = idx
          self.ductWord = data.data

        }
      },

      isRegular (val) {
        // eslint-disable-next-line no-useless-escape
        let pattern = new RegExp(/[\p{P}\s]/u)
        if (val && val.match(pattern)) {
          return true
        }
        return false
      },

      toggleSwitch () {
        let self = this
        if (self.ttsUrlFemale && self.ttsUrlMale) {
          self.isShowPlayer = !self.isShowPlayer
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .btn-player-disabled {
    border-radius: 8px;
    border: 1px solid #F30000;
    background: #FFF;
    color: #F30000;
    text-align: center;
    font-family: Noto Sans;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    min-width: 160px;
    cursor: default;
    opacity: 0.3;
  }
  .results {
    line-height: 1.8;
    .results_en {
      p {
        white-space: pre-line;
        word-break: normal;
        margin-bottom: 0;
        span {
          position: relative;
        }
        .isDictionary {
          &:hover {
            background-color: #BBDDFF;
          }
        }
        .active {
          background-color: #BBDDFF;
        }
      }
    }
    .results_zh {
      border-left: 4px solid #2A86E0;
      color: #135BA3;
    }
  }
  .block {
    display: block;
  }
  .hover-item {
    .on {
      display: none;
    }
    &:hover {
      .off {
        display: none;
      }
      .on {
        display: block;
      }
    }
  }
  .active {
    .off {
        display: none;
      }
    .on {
      display: block;
    }
  }
  .toggle-switch {
    width: 170px;
    height: 48px;
    background-color: #0E103E;
    border-radius: 35px;
    background-image: url('~@/assets/image/ai/icon_voice_female_off.png'), url('~@/assets/image/ai/icon_voice_male_off.png');
    background-repeat: no-repeat;
    background-position: top 4px left 4px, top 4px right 4px;
    transition: .3s;
    .toggle-switch-button {
      top: 4px;
      z-index: 99;
    }
    .toggle-switch-button_female {
      left: 4px;
      .male {
        opacity: 0;
      }
    }
    .toggle-switch-button_male {
      right: 4px;
      .female {
        opacity: 0;
      }
    }
  }
</style>
